
import moment from "moment";
export default {
  props: {
    packageArea:{
      type: String,
      default: ""
    },
    packageVenue: {
      type: String,
      default: 'Place Name'
    },
    packageName: {
      type: String,
      default: ""
    },

    bcount: {
      type: Number,
      default: 0
    },

    newTab: {
      type: Boolean,
      default: false
    },

    cateagoryName: {
      type: String,
      default: ''
    },
    packageLink: {
      type: String,
      default: "#"
    },
    bestSeller: {
  type: Boolean,
  default: false
},

    packageRating: {
      type: Number,
      default: 0
    },
    packageImage: {
      type: String
    },
    packageVenue: {
      type: String
    },
desc:{
  type: String,
  default: 'Description Text'
},

  },
  methods:{
    goToLink(links){
      this.$router.push({  path: links  })
    },
    bookingCalculator(value){

if(value < 1000){
  if(value > 100){
    let val = parseInt(value / 100, 10) * 100;
    return val
  }
  else{
    return value
  }

}else{
  let len = value.length;
  let sym = len>6?'m':'k';
  let firstDigit = value.toString()[0];
  return firstDigit + sym
}
    }
  }

}
